import cx from "classnames";

// Components
import Section from "../../../components/Section/SectionContainer";
import Vimeo from "../../../components/Vimeo/VimeoContainer";

// CSS
import styles from "../video.module.scss";

const VideoEmbed = (props) => {
    const { video } = props;
    const { video_disclaimer } = video || {};


    return (
        <Section classes={styles.embed}>
          <div className={styles.quality}>
              <span>
              To have the best experience when viewing this video, please ensure your quality setting is 1080p.
              </span>
          </div>
          <Vimeo video={video} />
          <div className={styles.disclaimer}>
              <span>This content features products and functionality that are offered or being developed by Symphony at the time of recording. Future availability is subject to change.
</span>
          </div>

          <div
              className={cx(styles.disclaimer_addendum, {
              [styles["disclaimer_addendum--hidden"]]: !video_disclaimer,
          })} >
              { video_disclaimer }
          </div>

        </Section>
    );
};

export default VideoEmbed;
